<template>
  <div>
    <Cursor />
    <Preloader v-if="pageLoader.loading" />
    <router-view></router-view>
  </div>
</template>

<script setup>
import Cursor from '@/components/Cursor.vue'
import { watch } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useSeoStore } from '@/stores/seo'
import Preloader from "@/components/Preloader.vue";
import { pageLoader } from "@/stores/pageLoader";

const route = useRoute()
const { locale } = useI18n()
const seoStore = useSeoStore()

watch(
  () => route.params.locale,
  async (newLocale) => {
    if (!newLocale) return

    locale.value = newLocale
    await seoStore.setLocale(newLocale)
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped></style>